import { useEffect } from "react";
import { AppRoutes } from "../types/enums";
import { useNavigate } from "react-router-dom";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

export const useNotFoundRedirect = ({
  error,
}: {
  error: FetchBaseQueryError | SerializedError | undefined;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (
      error &&
      "status" in error &&
      (error.status === 404 || error.status === 422)
    ) {
      navigate(AppRoutes.CAMPAINGS, { replace: true });
    }
  }, [error]);
};
